module.exports = " <div class=row> <div class=col-sm-2> <label for=clerkLedger.attributes.ledger_contents_pf class=\"label-left control-label\">Ledger Contents Pf</label> </div> <div class=col-sm-10> <input type=text ng-model=clerkLedger.attributes.ledger_contents_pf name=clerkLedger.attributes.ledger_contents_pf id=clerkLedger.attributes.ledger_contents_pf class=\"form-control m-b\"/> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/persistence.html
// module id = 2510
// module chunks = 86